export interface IProfile {
    id: number,
    accountRefId: string,
    username: string,
    firstName: string,
    lastName: string,
    email: string,
    mobile: string,
    mobileCountryId: number,
    mobileCountryCode: string,
    countryId?: number,
    countryName?: string,
    countryResourceKey?: string,
    languageId?: number,
    languageName?: string,
    languageResourceKey?: string,
    timezoneId?: number,
    timezoneName?: string,
    timezoneResourceKey?: string,
    companyName?: string,
    website?: string,
    isWAWebhookVerified: boolean | null,
    contactMaxAttributes: number,
    isChatbotEnabled: boolean | null,
    isTestingAccount: boolean | null,
    isConversationalCommerceEnabled: boolean | null,
    isAiVoiceAgentEnabled: boolean | null,
    isEmailChannelEnabled:boolean | null,
    planStatusId?: number,
    trialEndDate?: Date,
    remainingSandBoxWAMessages?: number,
}

export enum planFeatureFlags {
    isChatbotEnabled = 'chatbot.access',
    isConversationalCommerceEnabled = 'cc.access',
    isAiVoiceAgentEnabled = 'ai.voice.agent.access',
    isEmailChannelEnabled = 'email.channel.access'
}